import type { User } from '../../types/comments';
import { EntityCommentThread } from './EntityCommentThread';

interface EmailThreadCommentThreadProps {
  conversationId: number;
  users: User[];
  currentUser: User;
  isReadOnly?: boolean;
}

/** Thin adapter over {@link EntityCommentThread} for a mail conversation's discussion. */
export function EmailThreadCommentThread({
  conversationId,
  ...rest
}: EmailThreadCommentThreadProps) {
  return <EntityCommentThread target={{ type: 'emailThread', conversationId }} {...rest} />;
}
